import * as React from 'react';

import { ProductCardPlaceholder } from '@notino/react-styleguide';

import { StyledCardPlaceholderItem, StyledCardPlaceholderList } from './styled';

interface IProductsSectionPlaceholderProps {
  itemsPerSlide: number;
  listLabel?: string;
  rows?: number;
}

export const ProductsSectionPlaceholder: React.FC<
  IProductsSectionPlaceholderProps
> = ({ itemsPerSlide, listLabel = '', rows = 4 }) => (
  <StyledCardPlaceholderList
    id={listLabel}
    data-testid="product-items-placeholder"
  >
    {Array.from({ length: itemsPerSlide }, (_, index) => (
      <StyledCardPlaceholderItem
        key={`product-card-placeholder-${index}`}
        data-testid="product-item-placeholder"
      >
        <ProductCardPlaceholder rows={rows} />
      </StyledCardPlaceholderItem>
    ))}
  </StyledCardPlaceholderList>
);
